import React, { Component } from 'react';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';

import Utils from 'yeffect/utils';
import * as Actions from '../auth/store/actions';
import {API, populateRole} from "../config";

export default function (ComposedComponent) {
	class LoadUserData extends Component {
		state = {
			user:''
		}

		componentWillMount() {
			var controller = this;

			if (!Utils.isEmpty(window.localStorage.getItem('feathers-jwt'))) {
				API.authenticate({
					strategy: 'jwt',
					accessToken: window.localStorage.getItem('feathers-jwt')
				}).then((response) => {
					API.passport.verifyJWT(response.accessToken).then((data) => {
						API.service('users').get(data.userId).then((u) => {
                            var payload = {
                                data:{
                                    data: {
                                        'displayName': u.userFirstName + ' ' + u.userLastName,
                                        'photoURL'   : 'assets/images/avatars/profile.jpg',
                                        'email'      : u.email,
                                        'ident'      : u.id,
                                        //shortcuts    : Utils.populateFooter(u.permissions),
                                        settings:{}
                                    },
                                    role: populateRole(u.permissions)
                                }
                            }

                            controller.props.setUserData(payload.data);
							//controller.props.setUserDataFromDB(u);
							controller.setState({user:u})
						})
					})
				}).catch((error) => {
                    console.log(error);
					this.props.history.push({
						pathname: '/login'
					});
				})
			}
		}

		render() {

			return <ComposedComponent user={this.state.user} dbuser={this.state.user} userid={this.state.user.id}/>
		}
	}

	function mapDispatchToProps(dispatch)
	{
		return bindActionCreators({
			setUserData: Actions.setUserData,
			setUserDataFromDB: Actions.setUserDataFromDB,
		}, dispatch);
	}

	function mapStateToProps({ fuse, auth }) {
		return {
			login: auth.login,
			user: auth.user
		}
	}

	return connect(mapStateToProps, mapDispatchToProps)(LoadUserData);
}


// WEBPACK FOOTER //
// ./src/main/LoadUserData.js